class Form extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form');
    
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      const action = this.form.getAttribute('action');
      const inputs = this.form.querySelectorAll("[name]")
      const body = this.getUrlString(this.formToJSON(inputs));
      const successText = this.querySelector('[data-success-text]');
      const errorText = this.querySelector('[data-error-text]');

      successText.classList.add('hidden');
      errorText.classList.add('hidden');
      
      fetch(action, {
				method: 'POST',
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Accept": "application/json"
				},
				body: body
			})
      .then(res => {
        if(res.status == 200) {
          successText.classList.remove('hidden')
          setTimeout(() => {
            successText.classList.add('hidden')
          }, 3000);
        }
      })
      .catch(err => {
        errorText.classList.remove('hidden')
      })
    })
  }

  getUrlString(data) {
    var urlParameters = Object.entries(data).map(function (e) {
      return e.join('=');
    }).join('&');
  
    return urlParameters;
  }

  formToJSON(elements) {
    return [].reduce.call(elements, function (data, element) {
      data[element.name] = element.value;
      return data;
    }, {});
  }
  
}

customElements.define('form-component', Form);